import type { WarningSeverity } from '../../../types/WarningSeverity';

export interface WarningColumnValue {
  severity: WarningSeverity;
  /** nodeId refers to the id of the node from which this warning was propagated. */
  nodeId: string;
}

export const WARNING_COLID = 'warning';
